import { transformCurrencyAmountDto } from './currency-amount';
export const transformOfflineVerificationDto = _ref => {
  let {
    fee,
    enabled
  } = _ref;
  return {
    fee: transformCurrencyAmountDto(fee),
    enabled
  };
};